{
  "title": "Cycle Count",
  "subtitle": "Compare counted quantities against system stock and post variances.",
  "add": "New Cycle Count",
  "edit": "Edit",
  "open": "Open",
  "table": {
    "number": "Cycle Count #",
    "warehouse": "Warehouse",
    "date": "Date",
    "lines": "Lines",
    "status": "Status"
  },
  "form": {
    "warehouse": "Warehouse",
    "material": "Material",
    "addLine": "Add Line"
  },
  "dialog": {
    "systemQty": "System Qty",
    "countedQty": "Counted Qty",
    "client": "Client",
    "saveCounts": "Save Counts",
    "complete": "Complete & Post Variance"
  },
  "save": "Save",
  "cancel": "Cancel"
}
